import { FC } from 'react';

import { useModal } from 'components/ModalProvider/hooks';
import EditMenu from 'features/Work/components/EditMenu';
import { MenuItem } from 'features/Work/components/EditMenu/types';
import { useClientModals } from 'features/Work/hooks/useClientModals';

import { useClientModalContext } from '../../../../../../components/Modals';
import { ClientModalType } from '../../../../../../components/Modals/types';
import { Client as ClientFromDetails } from '../../../../../Details/types';
import { ClientFromList } from '../../../../hooks/queries/useGetClients';
import locales from './locales';

type ClientLike = ClientFromDetails | ClientFromList;

interface ListItemMenuProps {
  client: ClientLike;
}

const ListItemMenu: FC<ListItemMenuProps> = ({ client }) => {
  const { showModal } = useModal();
  const { openModal } = useClientModals();
  const { setClient } = useClientModalContext();
  const menuItems: MenuItem[] = [
    {
      icon: 'edit',
      onClick() {
        setClient(client);
        showModal(ClientModalType.CreateEdit);
      },
      title: locales.edit,
    },
    {
      colorScheme: 'red',
      icon: 'trash',
      onClick() {
        setClient(client);

        openModal({
          name: 'delete',
          props: client,
        });
      },
      title: locales.delete,
    },
  ];
  return <EditMenu menuItems={menuItems} />;
};

export default ListItemMenu;
